import { render, staticRenderFns } from "./upload-idcard.vue?vue&type=template&id=55990fcd&scoped=true&"
import script from "./upload-idcard.vue?vue&type=script&lang=js&"
export * from "./upload-idcard.vue?vue&type=script&lang=js&"
import style0 from "./upload-idcard.vue?vue&type=style&index=0&id=55990fcd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55990fcd",
  null
  
)

export default component.exports